/*
 * Copyright (c) 2018 Infowijs.
 * Created by Thomas Schoffelen.
 */

function linkExternal () {
  $('.page-content a').attr('target', function () {
    if (this.host === location.host || this.href.indexOf('mailto:') >= 0) {
      return '_self'
    }
    return '_blank'
  }).on('click', function () {
    if (this.hash && this.hash.length) {
      const hash = this.hash
      $(document).one('pjax:end', function () {
        const $hash = $(hash)
        if ($hash.length) {
          const offset = $hash.offset().top - 40
          const timeout = 200 + Math.round(Math.abs($(window).scrollTop() - offset) / 10)
          $('html, body').animate({
            scrollTop: offset
          }, timeout)
          setTimeout(updateTocIndex, timeout)
        }
      })
    }
  })
}

$(document).on('pjax:end', linkExternal)
linkExternal()
